// @flow

import React from 'react';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';

import Toggler from '../UI/Toggler';
import makeUrl from '../../lib/makeUrl';
import LoginOrLogout from './LoginOrLogout';
import DropdownElements from './DropdownElements';
import { isSuperUser } from '../../lib/utils';

type Props = {
  logout: () => void,
  openLoginModal: () => void,
  openSignUpModal: () => void,
  name: string,
  isUserLoggedIn: boolean,
  userInfo: {
    image: string,
    userId: string,
    name: string,
  },
  location: Object,
};

export default function UserDropdown(props: Props) {
  const {
    logout,
    openLoginModal,
    openSignUpModal,
    userInfo,
    isUserLoggedIn,
    location,
  } = props;

  let urlOfProfile = '',
    urlOfPurchaseList = '';

  if (isUserLoggedIn) {
    const { name, userId } = userInfo;

    urlOfProfile = makeUrl.goToProfile(name, userId);
    urlOfPurchaseList = `${makeUrl.goToProfile(name, userId)}/purchase-list`;
  }
  return (
    <Toggler>
      {({ on, toggle }) => (
        <Dropdown isOpen={on} toggle={toggle} className="user-btn-dp">
          <DropdownToggle caret color="none" className="btn-nav-bar dp-toggle">
            <div className="notification-icon_container user-navbar">
              {isUserLoggedIn ? (
                <img src={userInfo.image} alt={userInfo.name} />
              ) : (
                <img src="https://s3.amazonaws.com/honeyguide/assets/icons/user.svg" alt=""/>
              )}
            </div>
          </DropdownToggle>
          <DropdownMenu className="setting-dp" right>
            <DropdownElements
              link={urlOfProfile}
              title="Profile"
              isElementVisible={isUserLoggedIn}
              location={location}
            />

            {/* <DropdownItem divider /> */}

            <DropdownElements
              link={urlOfPurchaseList}
              title="Purchase List"
              isElementVisible={isUserLoggedIn}
              location={location}
            />

            {/* <DropdownItem divider /> */}

            <DropdownElements
              link={'/policies/terms-services'}
              title="Terms of Services"
              isElementVisible={true}
              location={location}
            />

            {/* <DropdownItem divider /> */}

            <DropdownElements
              link={'/admin'}
              title="Admin Dashboard"
              isElementVisible={isSuperUser()}
              location={location}
            />

            <DropdownElements
              link={'/admin/bookings'}
              title="Bookings Dashboard"
              isElementVisible={isSuperUser()}
            />

            {/* see pinterest logout button */}
            <LoginOrLogout
              isLoggedIn={isUserLoggedIn}
              logout={logout}
              openLoginModal={openLoginModal}
              openSignUpModal={openSignUpModal}
            />
          </DropdownMenu>
        </Dropdown>
      )}
    </Toggler>
  );
}



// WEBPACK FOOTER //
// ./src/components/TopBar/UserDropdown.jsx